import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyDataCollectionDto } from '../../models/api/companyDataCollectionDto';
import { UpsertDataCollectionRequest } from '../../models/api/upsertDataCollectionRequest';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataCollectionService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  /**
   * Returns a YearlyResource. State may be 'present' (record entered for the year),
   * 'inherited' (older record's validity period covers the year — hints.effectiveYear
   * carries the source year), or 'absent'.
   */
  get(companyId: string, year?: number): Observable<YearlyResource<CompanyDataCollectionDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyDataCollectionDto>>(
      `${this.apiUrl}/${companyId}/data-collection`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertDataCollectionRequest): Observable<CompanyDataCollectionDto> {
    return this.http.put<CompanyDataCollectionDto>(`${this.apiUrl}/${companyId}/data-collection`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/data-collection`, { params });
  }
}
